import React from "react";
import Switch from "./Switch";
export interface IRadioOption {
    label: string;
    value: string;
}
interface IProps {
    className?: string;
    options: IRadioOption[];
    selectedIndex: number;
    switch?: (selectedIndex: number) => void;
    tabIndex?: number;
}

function CustomRadioBox(props: IProps) {
    const renderOption = (option: IRadioOption, idx: number) => {
        return (
            <div key={"radioOption_" + idx} >
                <label>{option.label}</label>
                <Switch className={"switch"} value={idx === props.selectedIndex } switch={() => props.switch(idx)}/>
                <div className="clear"/>
            </div>
        );
    };
    return (
        <div
            className={`customSwitch ${props.className} ? ${props.className} : ""`}
            tabIndex={props.tabIndex}
            // style={{border: "1px solid red"}}
        >
            {props.options.map(renderOption)}
            <div className="border"/>
        </div>
    );
}
export default(CustomRadioBox);
